import { inject } from '@angular/core';
import type { IndustrialType } from '@indutrust/shared-model';
import {
  withCrudEntitiesEvents,
  withLoadAllOnAuthEvents,
} from '@indutrust/shared-util';
import { signalStore } from '@ngrx/signals';
import { IndustrialTypeApiClient } from '../industrial-type-api-client.service';
import { industrialTypeCrudEvents } from './industrial-type.events';

/**
 * Signal store managing IndustrialType entities and their loading state.
 *
 * Provides event-driven CRUD operations via {@link withCrudEntitiesEvents}.
 * API calls are automatically handled through the service factory passed to withCrudEntitiesEvents.
 *
 * @example
 * import { inject } from '@angular/core';
 * import { IndustrialTypeStore } from '@indutrust/shared-data';
 * const store = inject(IndustrialTypeStore);
 * store.loadAll();
 */
export const IndustrialTypeStore = signalStore(
  { providedIn: 'root' },
  withCrudEntitiesEvents<IndustrialType>(industrialTypeCrudEvents, () =>
    inject(IndustrialTypeApiClient)
  ),
  withLoadAllOnAuthEvents(industrialTypeCrudEvents)
);
